// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-header-ops__dropmenu {\n  padding: 10px 0px;\n}\n.x-header-ops__dropmenu .ant-dropdown-menu-item {\n  padding-left: 23px;\n  padding-right: 23px;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
